import { forwardRef } from 'react';
import { handleTrack } from '../../../../utils/tracker';
import { Button } from '../../../Atoms/Button';
import { IPageSection } from '../../types';

export const EventForm: React.FC<IPageSection> = forwardRef(
  ({ id, postData }, ref: React.ForwardedRef<HTMLDivElement>): JSX.Element => {
    return (
      <div className="bg-grey-190 sm:bg-white py-20 sm:pb-0">
        <div
          className="items-center flex justify-between sm:gap-12 wg-container sm:px-0 sm:flex-col-reverse"
          id={id}
          ref={ref}
        >
          <div className="lhs w-full sm:px-5 max-w-[600px]">
            <h2 className="font-bold text-s-48 sm:text-s-32 mb-4">
              Register now with us!
            </h2>
            <p className="text-s-20 font-medium sm:text-base mb-4">
              Register for our exciting webinar and learn best filing practices,
              how to plan your taxes, maximize savings and many more from our
              tax experts.
            </p>

            <a
              href={postData?.webinarUrl}
              rel="noreferrer"
              target="__blank"
              className="text-white"
              onClick={() =>
                handleTrack({ label: 'cta_register_webinar', obj: null })
              }
            >
              <Button className="px-14 py-3 bg-blue-350 sm:ml-0 rounded-sm sm:my-2 ml-2 sm:w-full">
                Register Now
              </Button>
            </a>
          </div>
          <img src="https://assets.clear.in/cleartax/images/1736307226_group18142219631.png" />
        </div>
      </div>
    );
  }
);

EventForm.displayName = 'EventForm';
